import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', hidden: true }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '仪表盘', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/tenant',
    component: () => import('@/layout/index.vue'),
    redirect: '/tenant/list',
    meta: { title: '租户管理', icon: 'el-icon-office-building', alwaysShow: true },
    children: [
      {
        path: 'list',
        name: 'TenantList',
        component: () => import('@/views/tenant/list.vue'),
        meta: { title: '租户列表' }
      },
      {
        path: 'detail/:id',
        name: 'TenantDetail',
        component: () => import('@/views/tenant/detail.vue'),
        meta: { title: '租户详情', hidden: true }
      }
    ]
  },
  {
    path: '/agent',
    component: () => import('@/layout/index.vue'),
    redirect: '/agent/list',
    meta: { title: '客服管理', icon: 'el-icon-user', alwaysShow: true },
    children: [
      {
        path: 'list',
        name: 'AgentList',
        component: () => import('@/views/agent/list.vue'),
        meta: { title: '客服列表' }
      },
      {
        path: 'detail/:id',
        name: 'AgentDetail',
        component: () => import('@/views/agent/detail.vue'),
        meta: { title: '客服详情', hidden: true }
      }
    ]
  },
  {
    path: '/conversation',
    component: () => import('@/layout/index.vue'),
    redirect: '/conversation/list',
    meta: { title: '会话管理', icon: 'el-icon-chat-dot-round', alwaysShow: true },
    children: [
      {
        path: 'list',
        name: 'ConversationList',
        component: () => import('@/views/conversation/list.vue'),
        meta: { title: '会话列表' }
      },
      {
        path: 'chat-records',
        name: 'ChatRecords',
        component: () => import('@/views/conversation/chat-records.vue'),
        meta: { title: '会话记录查询' }
      }
    ]
  },
  {
    path: '/department',
    component: () => import('@/layout/index.vue'),
    redirect: '/department/list',
    meta: { title: '部门管理', icon: 'el-icon-s-management', alwaysShow: true },
    children: [
      {
        path: 'list',
        name: 'DepartmentList',
        component: () => import('@/views/department/list.vue'),
        meta: { title: '部门列表' }
      }
    ]
  },
  {
    path: '/quick-reply',
    component: () => import('@/layout/index.vue'),
    redirect: '/quick-reply/list',
    meta: { title: '快捷回复', icon: 'el-icon-edit-outline', alwaysShow: true },
    children: [
      {
        path: 'list',
        name: 'QuickReplyList',
        component: () => import('@/views/quick-reply/list.vue'),
        meta: { title: '回复列表' }
      }
    ]
  },
  {
    path: '/tenant-user',
    component: () => import('@/layout/index.vue'),
    redirect: '/tenant-user/list',
    meta: { title: '用户管理', icon: 'el-icon-s-custom', alwaysShow: true },
    children: [
      {
        path: 'list',
        name: 'TenantUserList',
        component: () => import('@/views/tenant-user/list.vue'),
        meta: { title: '租户用户列表' }
      },
      {
        path: 'global-list',
        name: 'GlobalUserList',
        component: () => import('@/views/tenant-user/global-list.vue'),
        meta: { title: '用户列表' }
      }
    ]
  },
  {
    path: '/statistics',
    component: () => import('@/layout/index.vue'),
    redirect: '/statistics/overview',
    meta: { title: '统计分析', icon: 'el-icon-s-data', alwaysShow: true },
    children: [
      {
        path: 'overview',
        name: 'StatisticsOverview',
        component: () => import('@/views/statistics/overview.vue'),
        meta: { title: '统计概览' }
      },
      {
        path: 'agent',
        name: 'StatisticsAgent',
        component: () => import('@/views/statistics/agent.vue'),
        meta: { title: '客服统计' }
      }
    ]
  },
  {
    path: '/system',
    component: () => import('@/layout/index.vue'),
    redirect: '/system/admin',
    meta: { title: '系统管理', icon: 'el-icon-setting', alwaysShow: true },
    children: [
      {
        path: 'admin',
        name: 'SystemAdmin',
        component: () => import('@/views/system/admin.vue'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'param',
        name: 'SystemParam',
        component: () => import('@/views/system/param.vue'),
        meta: { title: '系统参数' }
      },
      {
        path: 'log',
        name: 'SystemLog',
        component: () => import('@/views/system/log.vue'),
        meta: { title: '操作日志' }
      }
    ]
  },
  {
    path: '/profile',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '',
        name: 'Profile',
        component: () => import('@/views/profile/index.vue'),
        meta: { title: '个人中心', hidden: true }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
